document.addEventListener("DOMContentLoaded", function () {
  var mapElement = document.querySelector(".FeaturedMap__GMap");
  if (mapElement) {
    const settings = JSON.parse(mapElement.getAttribute("data-settings"));
    new GoogleMap("AIzaSyDUBrDnquKX6wZ2rGQYgMZDe8CzFiTLjL4", settings);
  }
});
class GoogleMap {
  constructor(apiKey, options) {
    this.options = options;
    if (!apiKey) {
      apiKey = options["apiKey"];
    }
    this.loadScript(apiKey).then(() => {
      this.init();
    });
  }
  loadScript(apiKey) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement("script");
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(
        apiKey
      );
    });
  }
  init() {
    var _this2 = this;
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode(
      {
        address: this.options["mapAddress"],
      },
      function (results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          if (Shopify.designMode);
        } else {
          var mapOptions = {
            zoom: _this2.options["zoom"],
            center: results[0].geometry.location,
            draggable: false,
            clickableIcons: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true,
          };
          var map = new google.maps.Map(
              document.querySelector(".FeaturedMap__GMap"),
              mapOptions
            ),
            center = map.getCenter();
          map.setCenter(center);
          var icon = {
            path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
            fillColor: _this2.options["markerColor"],
            fillOpacity: 1,
            anchor: new google.maps.Point(15, 55),
            strokeWeight: 0,
            scale: 0.6,
          };
          new google.maps.Marker({
            map: map,
            position: map.getCenter(),
            icon: icon,
          });
          //var styledMapType = new google.maps.StyledMapType(JSON.parse(document.querySelector('[data-gmap-style]').innerHTML));
          // map.mapTypes.set('styled_map', styledMapType);
          // map.setMapTypeId('styled_map');
          google.maps.event.addDomListener(window, "resize", function () {
            google.maps.event.trigger(map, "resize");
            map.setCenter(center);
          });
        }
      }
    );
  }
}
class LazyImage extends HTMLElement {
  constructor() {
    if ((super(), (this.image = this.querySelector("img")), this.image)) {
      this.handleLazy();
      new MutationObserver((t) => {
        t.forEach((t) => {
          (t.attributeName.includes("src") ||
            t.attributeName.includes("srcset")) &&
            this.handleLazy();
        });
      }).observe(this.image, { attributes: !0 });
    }
  }
  handleLazy() {
    this.image.complete ||
      (this.classList.add("loading"),
      this.image.addEventListener(
        "load",
        () => {
          this.classList.remove("loading");
        },
        !1
      ));
  }
}
customElements.define("lazy-image", LazyImage);
